import { Model } from '@/models/Model';

export class Option extends Model {
  protected $name: string = 'Option';
  protected $endpoint: string = '/options';
  protected $fillable: string[] = [
    'Size',
    'Colour',
  ];

  public product?: Product;
}

interface Product {
  size?: string;
  Colour?: string;
}
